'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import PageWrapper from '@/components/general/PageWrapper';
import Button from '@/components/common/Button';
import styles from './error.module.css';

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const t = useTranslations('common');

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <PageWrapper className={styles.wrapper}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('errorPageTitle')}</h1>
        <p className={styles.text}>{t('errorPageText')}</p>
        <Button onClick={reset}>{t('tryAgain')}</Button>
      </div>
    </PageWrapper>
  );
}
